module.exports = __webpack_public_path__ + "img/1266917699.ac4fd67e.jpg";